import Mockman from "mockman-js";
import "./MockApi.css"

export const MockApi=()=>{
    return (
    <div className="mock-api">
        <Mockman colorScheme="dark"/>
    </div>
    )
}